import type { Dictionary } from "./en";

export const ru: Partial<Dictionary> = {
  "lang.select": "Язык",
  "lang.change": "Сменить язык",

  "nav.hot": "Хот",
  "nav.categories": "Категории",
  "nav.marketplace": "Маркетплейс",
  "nav.fund": "Финансирование",
  "nav.promote": "Продвижение",
  "nav.earn": "Заработок",
  "nav.referrals": "Рефералы",
  "nav.soon": "Скоро",
  "nav.login": "Войти",
  "nav.dashboard": "Кабинет",
  "nav.getHot": "Стать Hot",
  "nav.menu": "Меню",
  "nav.walletBalance": "Баланс Heat",
  "nav.home": "Главная BeHot.Now",
  "nav.profile": "Кабинет",
  "nav.messages": "Сообщения",
  "nav.logout": "Выйти",
  "nav.balance": "Баланс",

  "footer.tagline": "Одно место, чтобы находить, нанимать, продавать и продвигать. Попади в чарт. Стань HOT. Будь заметным.",
  "footer.howItWorks": "Как это работает",
  "footer.operatedBy": "Оператор:",
  "footer.disclosure":
    "Платные размещения явно отмечены как платные. Цены указаны в долларах США.",
  "footer.platform": "Платформа",
  "footer.comingSoon": "Скоро",
  "footer.legal": "Правовая информация",
  "footer.hotNow": "Сейчас в топе",
  "footer.hotHistory": "История HOT",
  "footer.getHot": "Стать Hot",
  "footer.referrals": "Рефералы",
  "footer.withdrawal": "Право на отказ",
  "footer.terms": "Условия использования",
  "footer.privacy": "Политика конфиденциальности",
  "footer.cookie": "Политика использования cookie",
  "footer.rights": "Все права защищены.",
  "footer.compareLeaderboards": "Сравнение с другими чартами",

  "home.h1.q": "Что такое",
  "home.h1.a1": "Это место, где",
  "home.h1.anything": "что угодно",
  "home.h1.a2": "может бороться за внимание!",
  "home.sub1": "Вы инфлюенсер, публичная личность или знаменитость?",
  "home.sub2":
    "Или у вас есть песня, концерт, профиль, бренд, стартап, приложение, продукт, бизнес, мероприятие или просто идея?",
  "home.getItOnCharts": "Выведите это в чарты",
  "home.now": "сейчас",
  "home.moreBoosts": "Больше бустов.",
  "home.higherRanking": "Выше позиция.",
  "home.morePeople": "Больше людей вас видят.",
  "home.more": "Ещё",
  "home.browseChart": "Открыть чарт «{label}»",
  "home.listIt": "РАЗМЕСТИ",
  "home.boostIt": "БУСТНИ",
  "home.climb": "ПОДНИМАЙСЯ",
  "home.getSeen": "БУДЬ ЗАМЕЧЕН",
  "home.howItWorks": "Как это работает",
  "home.generalBoard": "ОБЩИЙ ЧАРТ",
  "home.podium.title": "Топ-3 на каждой доске",
  "home.podium.sub": "Текущий подиум каждой категории.",
  "home.generalBoardSub":
    "Лучшие объявления из всех категорий по суммарному активному Heat.",
  "home.allBoards": "Все чарты",
  "home.loadingBoard": "Загружаем общий чарт…",

  "lowHeat.title": "Heat заканчивается",
  "lowHeat.body":
    "Heat заканчивается — пригласите друзей и получите больше Heat или пополните кошелёк сейчас.",
  "lowHeat.invite": "Пригласить друзей",
  "lowHeat.topUp": "Пополнить кошелёк",
  "lowHeat.later": "Позже",

  "cookie.title": "Мы используем cookie",
  "cookie.accept": "Принять все",
  "cookie.reject": "Отклонить необязательные",
  "cookie.settings": "Настройки cookie",
  "cookie.save": "Сохранить выбор",

  "common.close": "Закрыть",
  "common.loading": "Загрузка…",
  "hiw.h1": "Как работает BeHot.Now",
  "hiw.toc": "На этой странице",
  "hiw.toc.title": "Содержание",
  "hiw.toc.steps": "Пять шагов",
  "hiw.toc.rules": "Правила ранжирования",
  "hiw.toc.entry": "Как формируется цена входа",
  "hiw.toc.glossary": "Глоссарий",
  "hiw.toc.pricing": "Цены",
  "hiw.toc.faq": "Вопросы и ответы",
  "hiw.toc.roadmap": "Что дальше",
  "hiw.toc.services": "Все сервисы",
  "hiw.toc.contact": "Связаться с нами",
  "hiw.steps.title": "Пять шагов",
  "hiw.ready.title": "Готовы соревноваться?",
  "hiw.ready.body": "Разместите свой проект или посмотрите, что в тренде прямо сейчас.",
  "hiw.ready.list": "Разместиться сейчас",
  "hiw.ready.browse": "Смотреть чарты",
  "hiw.rules.title": "Правила ранжирования",
  "hiw.entry.title": "Как формируется цена входа в чарт",
  "hiw.entry.intro": "Войти в чарт просто, но цена динамическая. Вы всегда платите самый низкий активный Heat в чарте плюс шаг этого чарта. Пример ниже показывает, как это работает.",
  "hiw.entry.lowest": "Текущий самый низкий активный Heat в чарте",
  "hiw.entry.plus": "+ шаг",
  "hiw.entry.increment": "Шаг чарта",
  "hiw.entry.min": "Ваша минимальная стоимость входа",
  "hiw.entry.note": "Если чарт пуст или только что обновлён, стоимость входа равна стартовому предложению — обычно 3 Heat — поэтому первые участники заходят дёшево, пока гонка не разогрелась.",
  "hiw.heat": "{n} Heat",
  "hiw.glossary.title": "Глоссарий",
  "hiw.pricing.title": "Цены",
  "hiw.pricing.oneHeat": "Цена 1 Heat",
  "hiw.pricing.oneHeatNote": "Разовый платёж · без подписки",
  "hiw.pricing.listing": "Стоимость размещения",
  "hiw.pricing.listingNote": "Чтобы разместить проект в чарте",
  "hiw.pricing.entry": "Вход в чарт",
  "hiw.pricing.entryValue": "Самый низкий Heat + шаг",
  "hiw.pricing.entryNote": "Пример: 12 Heat + 1 = 13 Heat для входа",
  "hiw.pricing.opening": "Стартовое предложение",
  "hiw.pricing.openingNote": "Стоимость входа в новый или пустой чарт",
  "hiw.faq.title": "Часто задаваемые вопросы",
  "hiw.roadmap.title": "Что дальше",
  "hiw.soon": "Скоро",
  "hiw.promote.body": "Покупайте реальные промо-действия у авторов: посты, сторис, упоминания и коллаборации по фиксированным ценам, с эскроу и подтверждением выполнения.",
  "hiw.promote.more": "Подробнее о Promote",
  "hiw.earn.body": "Авторы публикуют прайс, получают заказы напрямую, сдают работу с подтверждением и выводят заработок в USD.",
  "hiw.earn.more": "Подробнее о Earn",
  "hiw.services.title": "Все сервисы — подробно",
  "hiw.services.intro": "BeHot.Now — это больше, чем чарт. Вот всё, что платформа умеет сегодня, и всё, что скоро появится.",
  "hiw.services.open": "Открыть {name}",
  "hiw.contact.title": "Напишите нам",
  "hiw.contact.intro": "Выберите сервис, к которому относится ваш вопрос — включая поддержку и отдел продаж — и мы направим его нужной команде.",
  "hiw.cta.title": "Готовы занять позицию 01?",
  "hiw.cta.button": "Войти в чарт",
  "stats.liveUsers": "{n} пользователей онлайн",
  "stats.totalVisits": "Всего визитов: {n}",
};
